module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjMiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPgogIDxyZWN0IHg9IjAuODUiIHk9IjEuNjUiIHdpZHRoPSIxNC4zIiBoZWlnaHQ9IjMuNSIgcng9IjAuNyIvPgogIDxwYXRoIGQ9Ik0yLjIgNS4xNXY4LjVjMCAuMzguMzEuNy43LjdoMTAuMmMuMzkgMCAuNy0uMzIuNy0uN3YtOC41Ii8+CiAgPHBhdGggZD0iTTYuMiA5LjFoMy42IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu_icons/13.svg
// module id = CvXd
// module chunks = 2